import { render, staticRenderFns } from "./cabinet-notifications-settings.vue?vue&type=template&id=771f816b&scoped=true&"
import script from "./cabinet-notifications-settings.vue?vue&type=script&lang=js&"
export * from "./cabinet-notifications-settings.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-notifications-settings.vue?vue&type=style&index=0&id=771f816b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771f816b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('771f816b')) {
      api.createRecord('771f816b', component.options)
    } else {
      api.reload('771f816b', component.options)
    }
    module.hot.accept("./cabinet-notifications-settings.vue?vue&type=template&id=771f816b&scoped=true&", function () {
      api.rerender('771f816b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/notifications/cabinet-notifications-settings.vue"
export default component.exports